import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TraduccionPipePipe} from './traduccionPipe/traduccion-pipe.pipe';
import { SafePipe } from './safe/safe.pipe';

@NgModule({
    declarations: [TraduccionPipePipe, SafePipe],
    imports: [
        CommonModule
    ],
    exports: [
        TraduccionPipePipe,
        SafePipe
    ]
})
export class PipesModule {}